import baseConfig from '@config/base.config';
import cookieUtils from '@utils/cookie.utils';

/**
 * 缓存数据key值列表
 */
export type LOCAL_DATA_KEYS =
    | 'experiencePagination' //experience列表分页信息
    | 'experienceSearchContent' //experience列表搜索值
    | 'experienceStatusFilter' //experience状态过滤类别
    | 'experienceColumnSort' //experience列表排序值
    | 'startGuideClosed' //Start Guide气泡收起状态
    | 'startGuideConfetti'; //Start Guide完成步骤撒花

interface StartGuideClosed {
    guideClosed: boolean;
}

interface StartGuideConfetti {
    visible: boolean;
}

interface LocalData {
    startGuideClosed: StartGuideClosed;
    startGuideConfetti: StartGuideConfetti;
}

/**
 * 缓存档案数据
 */
export default function useLocalData() {
    const localKey = 'ptmind-swr';

    function getLocalDataKey(key: string) {
        const sid = cookieUtils.getItem(baseConfig.LAST_PROFILE_ID);
        return key + '?sid=' + sid;
    }

    function _getLocalData() {
        const localDataString = localStorage.getItem(localKey);
        return localDataString ? JSON.parse(localDataString) : {};
    }

    function updateLocalData(key: LOCAL_DATA_KEYS, val: { [key: string]: any }) {
        const localData = _getLocalData();
        const localDataKey = getLocalDataKey(key);
        localData[localDataKey] = Object.assign({}, val, { lastUpdateTime: Date.now() });
        localStorage.setItem(localKey, JSON.stringify(localData));
    }

    function getLocalData(key: LOCAL_DATA_KEYS): { [key: string]: any } {
        const localData = _getLocalData();
        const localDataKey = getLocalDataKey(key);
        const data = localData[localDataKey] || {};
        delete data.lastUpdateTime;
        return data;
    }

    return {
        localKey,

        getLocalData,
        updateLocalData
    };
}
